import localeSettings from './en-US/settings';
import localeLogin from '@/views/desktop/Login/locale/en-US';
import localeEmailLogin from '@/views/desktop/emailLogin/locale/en-US';
import localeLayout from '@/views/desktop/Layout/locale/en-US';
import localePDFlist from '@/views/desktop/PDFlist/locale/en-US';
import localePPTedit from '@/views/desktop/PPTedit/locale/en-US';
import localePPTshare from '@/views/desktop/PPTshare/locale/en-US';
export default {
    'Model.addSuccess': 'Successfully',
    'Model.LoggedOut': 'Logged out',
    'Delete': 'Delete',
    'Delete.Success': 'Successfully',
    'Share.model.title': 'Share',
    'Share.model.closedtitle': 'Link sharing is closed',
    'Share.model.btntext': 'copylink',
    'Share.model.opendtitle': 'Link sharing is opend',
    'Share.model.stitle1': 'Only the author has access to this oration',
    'Share.model.stitle2': 'The Internet can be accessed via links',
    'Share.model.copy1': 'The link has been copied and is accessible only to the author',
    'Share.model.copy2': 'The link has been copied and can be viewed by users who have obtained links on the Internet',
    'Leave.model.title': 'Tips',
    'Leave.model.content': 'Detected modifications that have not been saved, do you want to save them?',
    'Leave.model.cancelText': 'Do not save',
    'Leave.model.okText': 'Save',
    i: {
        select: {
            loading: "Loading...",
            noMatch: ''
        },
        // 如果你用到了其他组件，可能也需要这些：
        message: {
            success: "Success",
            error: "Error",
        },
        modal: {
            okText: "OK",
            cancelText: "Cancel",
        },
        // ...
    },
    ...localeSettings,
    ...localeLogin,
    ...localeEmailLogin,
    ...localeLayout,
    ...localePDFlist,
    ...localePPTedit,
    ...localePPTshare,
};
